import { getAdminOffset, getClampValue, stringToHTML } from './helper/helper';

(function ($) {
	const state = {
		tab: {
			sliding: false
		}
	};

	productCarousel();
	formVariations();
	relatedProductsSlider();
	const tabSlider = tabNavigationSlider();
	tabScrolling();


	function formVariations() {
		const form = $('.variations_form');
		if (form) {

			let alt = form.find('.product--variation.alternate');

			// variation selection actions
			form.on('found_variation', function (e, variation) {

				if (variation.sample) {
					$('#product--cart--free-sample').show();
				} else {
					$('#product--cart--free-sample').hide();
				}

				// show/hide meta data
				$('[data-has-meta="true"]').each(function () {
					let html = variation[$(this).data('variationKey')];

					if ('' === html) {
						$(this).parents('.product--meta-data').addClass('hidden');
					} else {
						$(this).parents('.product--meta-data').removeClass('hidden');
					}
					$(this).html(html);
				});

				// show/hide stock notice
				const stockNotice = $('.product--stock-notice').get(0)
				stockNotice.style.display = !variation.is_in_stock ? 'block' : '';

				const tab = document.getElementById('tab-whats_included');

				if (tab) {
					const activeTab = tab.querySelector('.active');
					const noInfoNotice = tab.querySelector('.no-info');
					let productTab = null;

					// If no variation, then no option has been selected, return to product initial state.
					if (!variation) {
						const product_id = document
							.querySelector('form.cart')
							.getAttribute('data-product_id');

						variation = { variation_id: product_id };
					} else {
						productTab = tab.querySelector(
							`.hpy_product_grid[data-product-sku="${variation.sku}"]`
						);
					}

					if (!productTab) {
						productTab = tab.querySelector(
							`.hpy_product_grid[data-product-id="${variation.variation_id}"]`
						);
					}

					if (activeTab) {
						activeTab.classList.remove('active');
					}

					if (noInfoNotice) {
						noInfoNotice.parentElement.removeChild(noInfoNotice);
					}

					if (!productTab) {
						const notFound = stringToHTML(`<div class="product_list no-info">
								No information currently available, please contact us for more information.
							</div>`);
						tab.append(notFound.firstElementChild);
					} else {
						productTab.classList.add('active');
					}
				}

				// enable/disable add to cart buttons
				if (!variation.is_in_stock) {
					$('.product--cart--actions_buttons .button').addClass('disabled').removeClass('active').prop('disabled', true);
				} else {
					$('.product--cart--actions_buttons .button').removeClass('disabled').prop('disabled', false);
				}

			})
				// on variations form reset
				.on('reset_data', function () {
					$('[data-has-meta="true"]').each(function () {
						// show/hide meta
						let html = $(this).data('variationDefault');
						if ('' === html) {
							$(this).parents('.product--meta-data').addClass('hidden');
						} else {
							$(this).parents('.product--meta-data').removeClass('hidden');
						}
						$(this).html(html);
					});

					// enable add to cart buttons
					$('.product--cart--actions_buttons .button').removeClass('disabled').prop('disabled', false);
				});

			if (alt.length) {
				form
					.on('click', '.product--variation-reset', function () {
						let variations = $(this).parents('.product--variation').find('.product--variation_value')
						variations.find('select').val('').trigger('change');
						variations.find('.product--variation-item').removeClass('active');
					})
					.on('woocommerce_update_variation_values', function () {
						form.find('.product--variation_value').each(function () {
							let _this = $(this);
							let active = null;
							let options = [..._this.find('select option').map((i, option) => {
								if (option.selected) {
									active = option.value;
								}
								return String(option.value);
							})];
							let items = _this.find('.product--variation-item');

							items.each(function () {
								let item = $(this);
								let value = item.data('value').toString();
								if (options.includes(value)) {
									item.removeClass('disabled');
								} else {
									item.addClass('disabled');
								}

								if (active === value) {
									item.addClass('active');
								}
							});
						});
					})
					.on('click', '.product--variation-item', function () {
						let _this = $(this);
						if (_this.hasClass('disabled')) {
							return;
						}
						let select = _this.parents('.product--variation_value').find('select');
						_this.parent().find('.product--variation-item').removeClass('active');
						select.val(_this.data('value')).trigger('change');
					});
			}
		}
	}

	function setTabNavSliderScroll() {
		if (state.tab.sliding) {
			return;
		}

		const activeTab = $('#tabs--navigation li.active');
		if (tabSlider && activeTab.length > 0) {
			tabSlider.go(activeTab.data('index'));
		}
	}

	function tabScrolling() {

		let tabLinks = $('.wc-tabs a');

		if (tabLinks.length > 0) {

			setActiveTab();
			getActiveTab();
			setTabNavSliderScroll();

			tabLinks.on('click', function (e) {
				e.preventDefault();
				state.tab.sliding = true;
				let rect = document.querySelector('.wc-tabs').parentElement.getBoundingClientRect();
				let href = $(this).attr('href');

				if ('javascript;' === href) {
					href = $(this).data('src');
				}

				if (tabSlider) {
					tabSlider.go($(this).parent('li').data('index'));
				}

				gsap.to(window, {
					duration: 1,
					scrollTo: {
						y: href,
						offsetY: rect.height + getAdminOffset() + 1
					},
					ease: "power1.out",
					onComplete: function () {
						state.tab.sliding = false;
					}
				});
			});
			document.addEventListener('scroll', getActiveTab, { passive: true });
		}

		function getActiveTab() {
			let tabs = $('.woocommerce-Tabs-panel');
			let rect = document.querySelector('.wc-tabs--header').getBoundingClientRect();

			tabs.each(function () {
				let _thisRect = this.getBoundingClientRect();
				let mainOffset = (rect.height + getAdminOffset());
				let topOffset = _thisRect.top - mainOffset;
				let bottomOffset = _thisRect.top + _thisRect.height - mainOffset;
				let boundary = 10; // offset accepted boundary to account for padding between items

				if ((topOffset - boundary) < 0 && (bottomOffset + boundary) > 0) {
					setActiveTab($(this));
					setTabNavSliderScroll();
					return false;
				}
			})
		}

		function setActiveTab(tab) {

			let tabs = $('.woocommerce-Tabs-panel');
			if (!tabs.length) {
				return;
			}

			if (!tab) {
				tab = tabs.eq(0);
			}

			if ($('.wc-tabs li[data-id="' + tab.attr('aria-labelledby') + '"]').hasClass('active')) {
				return;
			}

			tabs.each(function () {
				$('.wc-tabs li[data-id="' + $(this).attr('aria-labelledby') + '"]').removeClass('active');
			});
			$('.wc-tabs li[data-id="' + tab.attr('aria-labelledby') + '"]').addClass('active');
		}
	}

	function productCarousel() {
		const main = new Splide('#product---image', {
			type: 'fade',
			pagination: false,
			arrows: false,
			cover: true,
			heightRatio: 1
		});

		const nav = document.getElementById('product--image_nav');
		if (nav) {
			const thumbnails = new Splide('#product--image_nav', {
				isNavigation: true,
				gap: "0.5rem",
				pagination: false,
				fixedWidth: getClampValue(80, 120, 480, 1200),
				updateOnMove: true,
			});

			thumbnails.on('overflow', function (isOverflow) {
				thumbnails.options = {
					arrows: isOverflow,
					drag: isOverflow,
				};
			});

			main.sync(thumbnails);
			main.mount();
			thumbnails.mount();
		} else {
			main.mount();
		}
	}

	function relatedProductsSlider() {
		const related = $('#related--products');


		if (related.length) {
			let splide = new Splide(related.get(0), {
				gap: `1rem`,
				fixedWidth: getClampValue(250, 300, 768, 1200),
				autoHeight: true,
				pagination: false,
				mediaQuery: 'min',
				omitEnd: true,
				breakpoints: {
					1200: {
						destroy: true,
					},
				}
			});

			splide.on('overflow', function (isOverflow) {
				splide.options = {
					arrows: isOverflow,
					drag: isOverflow,
				};
			})
			splide.mount();
		}
	}

	function tabNavigationSlider() {
		const tabs = $('#tabs--navigation');

		if (tabs.length) {
			let splide = new Splide(tabs.get(0), {
				gap: `1.5rem`,
				arrows: true,
				autoWidth: true,
				pagination: false,
				mediaQuery: 'min',
				omitEnd: true
			});

			splide.on('overflow', function (isOverflow) {
				splide.options = {
					drag: isOverflow,
				};
			})
			splide.mount();

			return splide;
		}

		return false;
	}


}(jQuery));